<!-- 第四次回访问卷 -->
<template>
  <div class="q3">
    <div class="container" v-if="info">
      <img
        class="bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e8c98e00099ee5d7823b2d86ed2dba44.png"
        alt=""
      />
      <div class="box">
        <div class="user-info">
          <div class="avatar" v-if="info.head_img">
            <img class="avatar-image" :src="info.head_img" alt="" />
          </div>
          <div class="nickname">{{ info.truename || info.nickname || '' }}</div>
        </div>
        <img
          class="icon"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/99c68f0b06187a5fba56e53e04399579.png"
          alt=""
        />
        <div class="desc" v-html="info.result_title"></div>
        <div class="desc1" v-html="info.result_content"></div>
        <div class="more" @click="bindMore">更多问卷</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getShareUrl } from '../../common.js'
export default {
  data() {
    return {
      info: null
    }
  },
  created() {
    this.getResult()
  },
  methods: {
    bindMore() {
      this.$router.push('/common-questions/home')
    },
    getResult() {
      let params = {
        que_user_id: this.$route.query.que_id,
        admin_uid: this.$route.query.admin_uid,
        que_id: this.$route.query.que_type
      }
      this.$http
        .getBaseAppWithHeader('que/QueBase/getQueResult', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.info = res.data
            this.$emit('copyUrl', getShareUrl(this.info.que_id))
          } else {
            this.$toast(res.msg)
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.q3 {
  overflow: hidden;
  background: #f7f7f7;
  min-height: 100vh;
  box-sizing: border-box;

  .container {
    position: relative;
    padding: 56px 16px 0px;
    background-image: linear-gradient(
      180deg,
      rgba(148, 173, 252, 1) 0px,
      rgba(148, 173, 252, 0) 350px
    );
    .bg {
      position: absolute;
      right: 30px;
      top: 10px;
      width: 121px;
      height: 109px;
      object-fit: contain;
      z-index: 1;
    }
    .box {
      position: relative;
      z-index: 2;
      background: #ffffff;
      box-shadow: 0px 5px 9px 0px rgba(58, 55, 82, 0.03);
      border-radius: 16px;
      border: 2px solid #ffffff;
      padding: 0px 26px 26px;
    }

    .user-info {
      width: 100%;
      margin-top: -26px;
      text-align: center;
      padding-bottom: 12px;
      border-bottom: 1px dashed rgba(58, 55, 82, 0.16);

      .avatar {
        margin: 0 auto;
        width: 54px;
        height: 54px;
        border: 2.5px solid #fff;
        box-sizing: border-box;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 6px;
        .avatar-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .nickname {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 22px;
      }
    }

    .icon {
      width: 114px;
      height: 114px;
      margin: 10px auto;
      object-fit: contain;
    }

    .desc {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #27243c;
      line-height: 22px;
      text-align: center;
      margin-bottom: 5px;
    }

    .desc1 {
      text-align: center;
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(39, 36, 60, 0.45);
      line-height: 20px;
      margin-bottom: 56px;

      .purple {
        color: rgba(159, 145, 254, 1);
      }
    }

    .more {
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      text-align: center;
      border: 1px solid rgba(82, 68, 133, 0.3);
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #524485;
    }
  }
}

.share {
  font-size: 24px;
}
</style>
